// @ts-nocheck
import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import phoneDevice from "./../../images/mobile_app_stars.svg";
import appleButton from "./../../images/svgs/apple-play.svg";
import googleButton from "./../../images/svgs/google-play-2.png";

import appleESButton from "./../../images/svgs/apple-play-es.svg";
import googleESButton from "./../../images/svgs/google-play-es.png";
import styles from "./DownloadApp.module.scss";
import {fireGA, fireSupGA} from "../../hooks/tagging";
// import content from "./content";
import classNames from "classnames";
import supStyles from "../atoms/Superscript/Superscript.module.scss";
import {scrollView} from "../../libs/scrollView";

const DownloadApp: FunctionComponent<{

      contentString: string

}> = ({
           contentString
      }) => {

    const paragraphRef = useRef<HTMLParagraphElement>(null)

    const initialized = useRef(false);
    const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';


    useEffect(() => {

        if(!initialized.current) {
            if (paragraphRef.current) {
                initialized.current = true;

                const sups = paragraphRef.current.querySelectorAll('A')
                sups.forEach((sup: any) => {
                    const keyUpHandler = (event: any) => {
                        if (event.which === 13) {
                            event.preventDefault();
                            event.stopPropagation();
                            fireSupGA({clickText: sup.innerText});
                            const target = document.getElementById(`fn-${sup.innerText}`)

                            scrollView(target, {behavior: "smooth", block: "center"}, () => setTimeout(() => {
                                target?.focus()
                            }, 500));
                        }
                    }

                    sup.addEventListener('keydown', (e: any) => keyUpHandler(e));

                    const clickHandler = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        fireSupGA({clickText: sup.innerText});

                        const target = document.getElementById(`fn-${sup.innerText}`)

                        scrollView(target, {behavior: "smooth", block: "center"}, () => setTimeout(() => {
                            target?.focus()
                        }, 500));
                    }
                    sup.addEventListener('click', (e: any) => clickHandler(e));

                    return () => {
                        document.removeEventListener('click', clickHandler);
                        document.removeEventListener('keydown', keyUpHandler);
                    };
                })

            }
        }
    })
    console.log(contentString)
    let superNumber = contentString === "startsmart" || contentString === "cardonoff" || (dataLang === "es" && contentString !== 'spending') ? 5 : 4;

    if (contentString === "default" && dataLang === "en") {
        superNumber = 3;
    }

    const content = {
        english: {
            headline: <>Join the millions who already trust Wells&nbsp;Fargo with their money&nbsp;needs</>,
            ratingText: <>The Wells Fargo Mobile app is rated an avg. 4.9 out of 5 stars by over 13 million customers.
                <a id={`body-sup-${superNumber}`} className={supStyles.bodySup} href=""><sup>{superNumber}</sup></a></>
        },
        spanish: {
            headline: <>Únete a las millones de personas que ya confían sus finanzas a Wells Fargo</>,
            ratingText: <>
                La app de Wells Fargo Mobile&reg; tiene una calificación promedio de 4.9 de 5 estrellas de más de 13 millones de clientes
                <a id={`body-sup-${superNumber}`} className={supStyles.bodySup} href="" aria-label={`nota al pie ${superNumber}`}><sup>{superNumber}</sup></a>.
            </>
        }
    }

    return (<section className={classNames([styles.downloadApp, 'no-parallax'])} data-tracking="section-app">
        <div lang={dataLang}>
            <div>

                <h2 className={styles.headline}>
                    {process.env.REACT_APP_LANG === "spanish" ? content.spanish.headline : content.english.headline}
                </h2>
            </div>
            <div className={styles.stars}>
                <img alt="" src={phoneDevice}/>
                <p ref={paragraphRef}>
                    {process.env.REACT_APP_LANG === "spanish" ? content.spanish.ratingText : content.english.ratingText}
                </p>
            </div>

            <div className={styles.mobileButtons}>
                <div>
                    <a
                        onClick={() => fireGA("C3", {innerText: "app store"})} //good
                        href="https://apps.apple.com/us/app/wells-fargo-mobile/id311548709"
                        target="_blank"
                    >
                        <img
                            alt={process.env.REACT_APP_LANG === "spanish" ? "Consiguelo en el App Store - abre una superposición de salida de terceros" : "Download on the Apple Store - opens a 3rd party exit overlay"}
                            src={process.env.REACT_APP_LANG === "spanish" ? appleESButton : appleButton}
                        />
                    </a>
                </div>
                <div>
                    <a
                        onClick={() => fireGA("C4", {innerText: "google play"})}//good
                        href="https://play.google.com/store/apps/details?id=com.wf.wellsfargomobile&pli=1"
                        target="_blank"
                    >
                        <img
                            alt={process.env.REACT_APP_LANG === "spanish" ? "Disponible en Google Play - abre una superposición de salida de terceros" : "Get it on Google Play - opens a 3rd party exit overlay"}
                            src={process.env.REACT_APP_LANG === "spanish" ? googleESButton : googleButton}
                            width={135}
                        />
                    </a>
                </div>
            </div>

        </div>
    </section>);
};

export default DownloadApp;
